import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXsplitComponent } from './simple-icons-xsplit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXsplitComponent ],
    exports:      [ SimpleIconsXsplitComponent ],
    bootstrap:    []
})
export class SimpleIconsXsplitModule {}
